export default __webpack_public_path__ + "media/images/user_photos/169-93df9fa62f00a88e0c17e9daacb6ccae.jpg";